<template>
  <div class="data_brain_wrap">
<!--    <div class="brain_title">软件与AI</div>
    <div class="brain_desc">数智赋能、高效协同，助力实现产业高质量发展</div>

    <el-row class="card_wrap" type="flex">
      <el-col
          v-for="(item, index) in cardList"
          :key="index"
          :lg="7"
          :sm="11"
          :xs="11"
          class="brain_item"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>
        <div class="item_bg"></div>
      </el-col>
    </el-row>-->


<!--    <div class="brain_title">领先的软硬产品结合</div>
    <div class="brain_desc">数智赋能、高效协同，助力实现产业高质量发展</div>

    <el-row class="card_wrap" type="flex">
      <el-col
          v-for="(item, index) in cardList"
          :key="index"
          :lg="7"
          :sm="11"
          :xs="11"
          class="brain_item"
      >
        <div class="item_title">{{ item.title }}</div>
        <div class="item_desc">{{ item.desc }}</div>
        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>
        <div class="item_bg"></div>
      </el-col>
    </el-row>-->



    <div class="brain_title">软件与AI</div>
    <div class="brain_desc">数智赋能、高效协同，助力实现产业高质量发展</div>

    <el-row class="card_wrap" type="flex">
      <el-col
          v-for="(item, index) in cardList"
          :key="index"
          :lg="7"
          :sm="11"
          :xs="11"
          class="brain_item"
      >
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="item_title">{{ item.title }}</div>
          <div class="item_navigate" @click="handleNavigate">了解详情 >></div>
        </div>

        <div class="item_desc">{{ item.desc }}</div>
        <img :src="item.src" alt="" class="img_item"/>

        <div class="item_bg"></div>
      </el-col>
    </el-row>



  </div>
</template>

<script>
export default {
  data() {
    return {
      /*cardList: [
        {
          title: '降本增效',
          desc: '通过实时数据分析和预测，优化生产调度，减少闲置时间，提高生产效率。自动识别生产瓶颈并提供解决方案，缩短生产周期。优化资源分配，减少原材料浪费和能源消耗。',
        },
        {
          title: '提质创优',
          desc: '通过全新智能充电设备，提升充电效能，实现智能化充电管理。利用先进技术优化充电速度与安全性，为用户提供更高效、便捷的充电体验。',
        },
        {
          title: '增强决策',
          desc: '提供数据驱动的洞察，帮助管理者做出更科学、更快速的决策。通过模拟和预测，支持生产计划的动态调整。',
        },
        {
          title: '智能化与自动化',
          desc: '推动制造业向智能化和自动化方向发展，减少对人力的依赖。实现从订单到交付的全流程自动化管理。',
        },
        {
          title: '供应链协同',
          desc: '通过分析供应链数据，优化库存管理和物流调度，减少库存积压和运输成本。实现供应链的智能化协同，提高整体运营效率。',
        },
        {
          title: '工艺优化',
          desc: '分析生产数据，优化工艺参数，提高生产效率和产品质量。通过机器学习模型，不断改进生产工艺。',
        },
      ],*/

      /*cardList: [
        {
          title: 'Saas新能源管控平台',
          desc: '通过实时数据分析和预测，优化生产调度，减少闲置时间，提高生产效率。自动识别生产瓶颈并提供解决方案，缩短生产周期。优化资源分配，减少原材料浪费和能源消耗。',
        },
        {
          title: '智慧矿山Saas管控平台',
          desc: '通过全新智能充电设备，提升充电效能，实现智能化充电管理。利用先进技术优化充电速度与安全性，为用户提供更高效、便捷的充电体验。',
        },
        {
          title: '企业数智化MES平台',
          desc: '提供数据驱动的洞察，帮助管理者做出更科学、更快速的决策。通过模拟和预测，支持生产计划的动态调整。',
        },
        {
          title: '充电模块系列',
          desc: '推动制造业向智能化和自动化方向发展，减少对人力的依赖。实现从订单到交付的全流程自动化管理。',
        },
        {
          title: '充电桩体系列',
          desc: '推动制造业向智能化和自动化方向发展，减少对人力的依赖。实现从订单到交付的全流程自动化管理。',
        },
        {
          title: '无人车自驾管控平台',
          desc: '推动制造业向智能化和自动化方向发展，减少对人力的依赖。实现从订单到交付的全流程自动化管理。',
        }
      ],*/



    cardList: [
      {
        title: '降本增效',
        desc: '通过实时数据分析与预测，优化生产调度与资源配置，识别并解决生产瓶颈，提升效率、降低消耗。',
        src:require('@/assets/img/aiCardListBg/card-1.png'),
      },
      {
        title: '提质创优',
        desc: '采用全新智能充电设备，优化充电效能、速度与安全，实现智能管理，带来高效便捷的充电体验。',
        src:require('@/assets/img/aiCardListBg/card-2.png'),
      },
      {
        title: '增强决策',
        desc: '提供数据驱动的洞察，帮助管理者做出更科学、更快速的决策。通过模拟和预测，支持生产计划的动态调整。',
        src:require('@/assets/img/aiCardListBg/card-3.png'),
      },
      {
        title: '智能化与自动化',
        desc: '推动制造业向智能化和自动化方向发展，减少对人力的依赖。实现从订单到交付的全流程自动化管理。',
        src:require('@/assets/img/aiCardListBg/card-4.png'),
      },
      {
        title: '供应链协同',
        desc: '依托供应链数据分析，优化库存与物流调度，降低积压及运输成本，实现智能协同，提升运营效率。',
        src:require('@/assets/img/aiCardListBg/card-5.png'),
      },
      {
        title: '工艺优化',
        desc: '分析生产数据，优化工艺参数，提高生产效率和产品质量。通过机器学习模型，不断改进生产工艺。',
        src:require('@/assets/img/aiCardListBg/card-6.png'),
      },
    ],



    }
  },
  methods: {
    handleNavigate() {
      this.$router.push('/production/1').catch((v) => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 50px 0;
  background: #e8eef2;
  text-align: center;

  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }

  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40PX;
    }
  }

  .card_wrap {
    width: 70%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-around;
    @media screen and (max-width: 768px) {
      width: 95%;
    }

    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40PX;
        border-radius: 10PX;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20PX;
        &:nth-child(-n+2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;

      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
                134deg,
                #0649b8 1%,
                #0a7fd7 41%,
                #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }

      &:hover .item_bg {
        opacity: 1;
      }

      &:hover .item_title {
        color: #fff;
      }

      &:hover .item_desc {
        color: #fff;
      }

      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 20px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }

      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110PX;
          text-indent: 2em;
          font-size: 12px;
        }
      }

      .img_item {
        width: 100%;
        height: 40%;
        position: inherit;
        z-index: 2;
        //@media screen and (max-width: 768px) {
        //  width: 70%;
        //  margin-top: 20PX;
        //}
      }

      .item_navigate {
        width: 100PX;
        height: 30PX;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        //margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10PX;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
